import React, { useEffect, useState } from "react";
import axios from "axios";
import * as API from "../../Endpoints/Endpoints";

const GameHistory = () => {
  const [gameData, setGameData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await axios.get(API.GET_PLAY_API);
        setGameData(response.data || []);
      } catch (err) {
        setError(err.response?.data?.error || "Failed to fetch game data");
      } finally {
        setLoading(false);
      }
    };
    fetchGameData();
  }, []);

  // Function to highlight the search term in the text
  const highlightText = (text) => {
    if (!text) return "N/A";
    const regex = new RegExp(`(${searchTerm})`, "gi");
    return text.toString().replace(regex, "<mark>$1</mark>");
  };

  // Function to check if the row matches the search term
  const rowMatchesSearch = (row) => {
    if (!searchTerm) return true; // If no search term, show all rows
    return Object.values(row).some((value) =>
      value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const filteredData = gameData.filter(rowMatchesSearch);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-semibold text-[#e64a32]">Game History</h1>
        <input
          type="text"
          placeholder="Search..."
          className="border border-gray-300 p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e64a32]"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {filteredData.length === 0 ? (
        <p className="text-gray-500">No data found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-300 rounded-lg shadow-lg table-auto">
            <thead>
              <tr className="bg-[#e64a32] text-white text-sm">
                {["ID", "Email", "Category", "Game Name", "Card Group", "Opened Cards", "Scenario", "User Input", "Response", "Time Elapsed", "Score"].map((heading, index) => (
                  <th key={index} className="border px-4 py-3 text-left whitespace-nowrap">
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((game, index) => (
                <tr key={index} className="even:bg-gray-100 hover:bg-gray-200 transition-all">
                  <td className="border px-4 py-2" dangerouslySetInnerHTML={{ __html: highlightText(game.playid) }}></td>
                  <td className="border px-4 py-2" dangerouslySetInnerHTML={{ __html: highlightText(game.email) }}></td>
                  <td className="border px-4 py-2" dangerouslySetInnerHTML={{ __html: highlightText(game.selectedCategory) }}></td>
                  <td className="border px-4 py-2" dangerouslySetInnerHTML={{ __html: highlightText(game.selectedGamename) }}></td>
                  <td className="border px-4 py-2" dangerouslySetInnerHTML={{ __html: highlightText(game.selectedCardGroups) }}></td>
                  <td className="border px-4 py-2" dangerouslySetInnerHTML={{ __html: highlightText(game.openedCards) }}></td>
                  <td className="border px-4 py-2" dangerouslySetInnerHTML={{ __html: highlightText(game.scenario) }}></td>
                  <td className="border px-4 py-2" dangerouslySetInnerHTML={{ __html: highlightText(game.userInput) }}></td>
                  <td className="border px-4 py-2 w-[250px]" dangerouslySetInnerHTML={{ __html: highlightText(game.response) }}></td>
                  <td className="border px-4 py-2 w-[150px]" dangerouslySetInnerHTML={{ __html: highlightText(game.timeElapsed && game.timeElapsed.minutes != null && game.timeElapsed.seconds != null ? `${game.timeElapsed.minutes}m ${game.timeElapsed.seconds}s` : "N/A") }}></td>
                  <td className="border px-4 py-2 w-[150px]" dangerouslySetInnerHTML={{ __html: highlightText(game.score) }}></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default GameHistory;
